import { formModes } from "EmbeddedForm.hook";

export const StartSelector = ({
  setMode,
  originator,
  providers,
  recipient,
  loading,
}) => {
  return (
    <>
      <div className="flex flex-row flex-wrap justify-center items-center gap-1">
        <button
          onClick={() => setMode(formModes.CREATE_REFERRAL)}
          className="bg-black mt-2 w-60 text-white font-bold py-3 px-6 rounded-xl hover:bg-gray-800"
        >
          Send a Referral
        </button>
        <button
          onClick={() => setMode(formModes.ASK_QUESTION)}
          className="bg-black mt-2 w-60 text-white font-bold py-3 px-6 rounded-xl hover:bg-gray-800"
        >
          Ask a Question
        </button>
      </div>
    </>
  );
};
